/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { PageFilterOperationEnum } from "./data/page-filter-operation.enum";

export function costCenterFilters(data: { costCenterIds?: string[]; filters?: IPageFilterElement[] }, key: string) {
  const costCenterFilters = data.costCenterIds
    ? data.costCenterIds.map(
        id =>
          new PageFilterElement({
            key,
            value: id,
            operation: PageFilterOperationEnum.EQUAL
          })
      )
    : [];

  const finalFilters = [...costCenterFilters, ...(data.filters ?? [])];

  return finalFilters;
}
